export default __webpack_public_path__ + "static/investment-image-1-530530db3699b4ee479baf9e47bc13bd.jpg";